import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'product-pagination',
  templateUrl: 'product-pagination.component.html',
  styleUrls: ['product-pagination.component.scss'],
})
export class ProductPaginationComponent {
  @Input() minimized: boolean = false;

  onPrevClick(event: MouseEvent) {
    console.log('click Prev');
  }
  onNextClick(event: MouseEvent) {
    console.log('click Next');
  }
}
